export default __webpack_public_path__ + "static/media/trybeTunes.c1c9d2ab.svg";